import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceResponse } from '@common/data-models/service/service-response';
import { IAuthService } from '@common/interfaces/i-auth.service';
import { LogonService } from '@common/services/logon-service';
import { NomWebServicesJson } from '@src/suite/common/services/nom-web-services-json';
import { AppService } from '@suite/app.service';

@Injectable({ providedIn: 'root' })
export class SSOService implements IAuthService {
    appService = inject(AppService);
    private logonService = inject(LogonService);
    private router = inject(Router);
    private nomWebServicesJson = inject(NomWebServicesJson);

    public providerName: string = null;

    public async authenticate(): Promise<ServiceResponse<void>> {
        this.navigateToAuth();
        return new ServiceResponse<void>(true);
    }

    public async loginWithToken(): Promise<ServiceResponse<void>> {
        const token = localStorage.getItem('idToken');
        const providerName = localStorage.getItem('providerName') ? localStorage.getItem('providerName') : '';
        return this.logonService.logonSSO(providerName, token);
    }

    public logout() {
        localStorage.removeItem('providerName');
        localStorage.removeItem('idToken');

        if (window['ANDROID_WRAPPER']) window['ANDROID_WRAPPER'].logout();
        this.nomWebServicesJson.clearSessionData();
        this.router.navigate(['/login']);
    }

    public async navigateToAuth() {
        const authAppUri = this.nomWebServicesJson.ssoConfigSettings()?.AuthAppUrl;
        if (window['ANDROID_WRAPPER']?.setAuthAppUrl) window['ANDROID_WRAPPER'].setAuthAppUrl(this.nomWebServicesJson.ssoConfigSettings()?.AuthAppUrl);
        // handling Microsoft Azure and Microsoft Live
        const provider = this.providerName.split(' ')[0];
        // have to get dynamically from g_config
        window.location.href = `${authAppUri}/#/?providerName=${provider}&redirectUri=${encodeURIComponent(window.location.href)}`;
    }
}
